import produce from 'immer';
import {
  CAMPAIGN_CHECK_PACKAGENAME,
  CAMPAIGN_SORT_UPDATE,
  RECOMMENDED_GAME_CREATE,
  RECOMMENDED_GAME_DETAIL_REQUEST,
  RECOMMENDED_GAME_LIST_REQUEST,
  RECOMMENDED_GAME_LOCK_STATE_UPDATE,
  RECOMMENDED_GAME_REMOVE,
  RECOMMENDED_GAME_TERMINATE,
  SET_CAMPAIGN_PAGINATION,
  SET_CAMPAIGN_RESPONSE,
  SET_CHECK_PACKAGENAME_RESULT,
  SET_MESSAGE_REQUEST,
  SET_RECOMMENDED_GAME_DETAIL,
  SET_RECOMMENDED_GAME_LIST,
  SET_SPECIAL_GAME_DETAIL,
  SET_SPECIAL_GAME_LIST,
  SPECIAL_GAME_CREATE,
  SPECIAL_GAME_DEPOSIT_REQUEST,
  SPECIAL_GAME_DETAIL_REQUEST,
  SPECIAL_GAME_LIST_REQUEST,
  SPECIAL_GAME_LOCK_STATE_UPDATE,
  SPECIAL_GAME_REMOVE,
  SPECIAL_GAME_TERMINATE,
} from '../../constants/app/campaignConstants';

const initialState = {
  campaignList: [],
  campaignInfo: {},
  page: 1,
  pageLength: 10,
  totalCount: 0,
  searchString: '',
  gameInfo: {},
  message: '',
  resultCode: null,
};

/* eslint-disable default-case, no-param-reassign */
const recommendedGameReducer = (state = initialState, action = {}) =>
  produce(state, (draft) => {
    switch (action.type) {
      case RECOMMENDED_GAME_LIST_REQUEST:
      case RECOMMENDED_GAME_DETAIL_REQUEST:
      case RECOMMENDED_GAME_CREATE:
      case RECOMMENDED_GAME_REMOVE:
      case RECOMMENDED_GAME_LOCK_STATE_UPDATE:
      case RECOMMENDED_GAME_TERMINATE:
      case CAMPAIGN_SORT_UPDATE:
      case SPECIAL_GAME_LIST_REQUEST:
      case SPECIAL_GAME_DETAIL_REQUEST:
      case SPECIAL_GAME_REMOVE:
      case SPECIAL_GAME_CREATE:
      case SPECIAL_GAME_LOCK_STATE_UPDATE:
      case SPECIAL_GAME_TERMINATE:
      case CAMPAIGN_CHECK_PACKAGENAME:
        break;
      case SET_RECOMMENDED_GAME_LIST:
      case SET_SPECIAL_GAME_LIST:
        draft.campaignList = action.list;
        break;
      case SET_RECOMMENDED_GAME_DETAIL:
      case SET_SPECIAL_GAME_DETAIL:
        draft.campaignInfo = action.info;
        break;
      case SET_CAMPAIGN_PAGINATION:
        draft.page = action.page;
        draft.totalCount = action.totalCount;
        draft.searchString = action.searchString;
        break;
      case SET_CHECK_PACKAGENAME_RESULT:
        draft.gameInfo = action.data;
        break;
      case SET_MESSAGE_REQUEST:
        draft.message = action.resultCode;
        break;
      case SET_CAMPAIGN_RESPONSE:
        draft.resultCode = action.resultCode;
        break;
      case SPECIAL_GAME_DEPOSIT_REQUEST:
        break;
      default:
        break;
    }
  });

export default recommendedGameReducer;
